<template>
  <j-modal
    :visible.sync="visible"
    :width="width"
    :title="title"
    :fullscreen.sync="fullscreen"
    :switchFullscreen="switchFullscreen"
    @ok="handleOk">
    `
    <a-row :gutter="10">
      <a-col :md="8" :sm="24">
        <a-card :bordered="true" title = "物料分类">
          <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px;" >
            <a-alert type="info" :showIcon="true">
              <div slot="message">
                当前选择：<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
                <a v-if="this.currSelected.title" style="margin-left: 10px" @click="onClearSelected">取消选择</a>
              </div>
            </a-alert>
            <!-- 树-->
            <a-col :md="10" :sm="24">
              <template>
                <a-tree
                  :defaultExpandAll="defaultExpandAll"
                  :selectedKeys="selectedKeys"
                  :checkedKeys="checkedKeys"
                  :treeData="treeData"
                  :expandedKeys="expandedKeys"
                  @select="onSelect"
                  @expand="onExpand"/>
              </template>
            </a-col>
          </div>
        </a-card>
        <!--<div class="drawer-bootom-button">
          <a-dropdown :trigger="['click']" placement="topCenter">
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="switchCheckStrictly(1)">父子关联</a-menu-item>
              <a-menu-item key="2" @click="switchCheckStrictly(2)">取消关联</a-menu-item>
              <a-menu-item key="4" @click="cancelCheckALL">取消全选</a-menu-item>
              <a-menu-item key="5" @click="expandAll">展开所有</a-menu-item>
              <a-menu-item key="6" @click="closeAll">合并所有</a-menu-item>
            </a-menu>
            <a-button>
              树操作 <a-icon type="up" />
            </a-button>
          </a-dropdown>
        </div>-->
      </a-col>

      <a-col :md="16" :sm="24">

        <a-table
          ref="table"
          size="large"
          bordered
          :rowKey="table.rowKey"
          :columns="table.columns"
          :dataSource="table.dataSource"
          :pagination="table.pagination"
          :loading="table.loading"
          :scroll="table.scroll"
          :customRow ="customRowFn"
          :rowSelection="{
            fixed: true,
            columnWidth: 40,
            type: multiSelectable ? 'checkbox':'radio',
            selectedRowKeys: table.selectedRowKeys,
            onChange: handleChangeInTableSelect}"
          @change="handleChangeInTable"
          style="min-height: 300px"
          class="j-table-force-nowrap">
        </a-table>
      </a-col>
    </a-row>
  </j-modal>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { getAction } from '@/api/manage'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import {filterObj} from '@/utils/util';

  export default {
    name: "MaterialSelectModal",
    mixins: [],
    components: {
    },

    props: {
      title: {
        type: String,
        default: '选择'
      },
      filterCode: {
        type: String,
        required: true
      },
      width: {
        type: Number,
        default: 1000
      },
      fullscreen: {
        type: Boolean,
        default: true
      },
      multiSelectable:{
        type: Boolean,
        default: true
      },
      switchFullscreen: {
        type: Boolean,
        default: true
      },
    },

    data() {
      return {
        visible: false,
        defaultExpandAll:false,
        //报表定义中的查询字段
        queryFields: [],
        tableQueryParam:{},
        //报表定义SQL中嵌入的参数
        sqlParams:{},
        sorter: {
          column: '',
          order: 'desc',
        },
        expandedKeys:[],
        currSelected: {},
        checkedKeys: [],
        selectedKeys: [],
        checkStrictly: true,
        autoExpandParent: true,
        iExpandedKeys: [],
        treeData: [],
        dictOptions: {},
        toggleSearchStatus: false, //搜索 展开/关闭
        description: '',
        url: {
          getMaterialCategory: '/bas/basMaterialCategory/loadTreeData',
          getTableData: '/bas/basMaterial/list',
          getqueryFields: '/online/cgreport/api/getQueryInfo/',
          getSqlParams:'/online/cgreport/api/getParamsInfo/'
        },
        table: {
          loading: false,
          // 表头
          columns: [
            {
              title: '#',
              key:'rowIndex',
              width:160,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title: '编码',
              dataIndex:'code',
              width:160,
              align:"center",
            },
            {
              title:'名称',
              dataIndex:"name",
              align:"center",
              width: 180,
            },
            {
              title:'计量单位',
              dataIndex:"unitId_dictText",
              align:"center",
              width: 180,
            }
          ],
          //数据集
          dataSource: [],
          // 选择器
          selectedRowKeys: [],
          selectionRows: [],
          rowKey:"id",
          scroll: {  y: 500 },
          // 分页参数
          pagination: {
            current: 1,
            pageSize: 15,
            pageSizeOptions: ['15', '30', '45'],
            showTotal: (total, range) => {
              return range[0] + '-' + range[1] + ' 共' + total + '条'
            },
            showQuickJumper: true,
            showSizeChanger: true,
            total: 0
          }
        },
        cgreportHeadName:"",
      }
    },

    created() {
      this.loadData()
    },
    mounted() {
    },

    methods: {
      onSelect(selectedKeys, e) {
        console.log('selected', selectedKeys, e)
        this.hiding = false
        let record = e.node.dataRef
        this.currSelected = Object.assign({}, record)
        this.model = this.currSelected
        this.selectedKeys = [record.key]
        this.model.parentId = record.parentId
        if (record.isLeaf) {
          this.loadTable(1);
        }else{
          // this.expandedKeys = []
          this.expandedKeys.push(record.key)
        }
      },
      customRowFn(record) {
        let that = this
        return {
          on: {
            click: () => {
              /*    that.table.selectedRowKeys = []
                  that.table.selectionRows = []*/
              /* let key = this.table.rowKey
              this.table.selectedRowKeys.push(record[key])
              this.table.selectionRows.push(record)*/
              let key = record[that.table.rowKey]
              if (!that.multiSelectable) {
                that.table.selectedRowKeys.push(key)
                that.table.selectionRows.push(record)
              } else {
                let index = that.table.selectedRowKeys.indexOf(key)
                if (index === -1) {
                  that.table.selectedRowKeys.push(key)
                  that.table.selectionRows.push(record)
                } else {
                  that.handleDeleteSelected(record, index)
                }
              }
            }
          }
        }
      },
      /** 删除已选择的 */
      handleDeleteSelected(record, index) {
        this.table.selectedRowKeys.splice(this.table.selectedRowKeys.indexOf(record[this.table.rowKey]), 1)
        this.table.selectionRows.splice(index, 1)
      },
      onClearSelected() {
        this.hiding = true
        this.checkedKeys = []
        this.currSelected = {}
        this.selectedKeys = []
        this.table.pagination.total = 0
        this.table.dataSource = []
        this.expandedKeys = []
      },
      onExpand(expandedKeys) {
        console.log('onExpand', expandedKeys)
        this.iExpandedKeys = expandedKeys
      },
      getCurrSelectedTitle() {
        return !this.currSelected.title ? '' : this.currSelected.title
      },
      loadData() {
        let params = {"condition":this.filterCode};//查询条件
        getAction(this.url.getMaterialCategory,params).then(res => {
          if (res.success) {
            var that = this
            that.treeData = []
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              that.treeData.push(temp)
            }
            this.loading = false
          }else{
            this.$message.warn('查询失败：'+res.message)
          }

        }).catch((e) => {
          console.error(e)
          this.$message.error('查询失败')
        }).finally(() => {
        })
      },
      loadTable(arg){
        this.table.selectedRowKeys = []
        this.table.selectionRows = []
        this.table.loading = true
        if (arg === 1) {
          this.table.pagination.current = 1
        }
        let categoryId = this.selectedKeys[0];
        console.log("categoryId: " + categoryId)
        let pageNo = this.table.pagination.current;
        let pageSize = this.table.pagination.pageSize;
        let qureyCondition = {"categoryId":categoryId,"pageNo":pageNo,"pageSize":pageSize}
        Object.assign(qureyCondition,this.tableQueryParam)
        console.log("qureyCondition: " + JSON.stringify(qureyCondition))
        getAction(this.url.getTableData, qureyCondition).then(res => {
          if (res.success) {
            if (res.result.records) {
              this.table.pagination.total = Number(res.result.total)
              this.table.dataSource = res.result.records
            } else {
              this.table.pagination.total = 0
              this.table.dataSource = []
            }
          }else{
            this.$message.warn('查询失败：'+res.message)
          }

        }).catch((e) => {
          console.error(e)
          this.$message.error('查询失败')
        }).finally(() => {
          this.table.loading = false
        })
      },

      initQueryParams(queryParams, readOnly = true) {
        this.table.selectedRowKeys = []
        this.table.selectionRows = []
        this.tableQueryParam = {}
        for(let x in queryParams){
          this.tableQueryParam[x] = queryParams[x]
        }
      },

      getQueryParams() {
        let param = Object.assign({}, this.queryParams, this.sorter,this.sqlParams);
        param.pageNo = this.table.pagination.current;
        param.pageSize = this.table.pagination.pageSize;
        return filterObj(param);
      },
      searchByQuery() {
        this.loadData(1);
      },
      searchReset() {
        let queryParams = {};
        for(let item of this.queryFields) {
          if (item.readOnly)  queryParam[item.field] = this.queryParams[item.field];
        }
        this.queryParams = queryParams;
        this.loadData(1);
      },
      handleToggleSearch() {
        this.toggleSearchStatus = !this.toggleSearchStatus;
      },
      handleChangeInTableSelect(selectedRowKeys, selectionRows) {
        this.table.selectedRowKeys = selectedRowKeys
        this.table.selectionRows = selectionRows
      },
      handleChangeInTable(pagination, filters, sorter) {
        //分页、排序、筛选变化时触发
        if (Object.keys(sorter).length > 0) {
          this.sorter.column = sorter.field
          this.sorter.order = 'ascend' === sorter.order ? 'asc' : 'desc'
        } else {
          this.sorter.column = null
          this.sorter.order = null
        }
        this.table.pagination = pagination
        this.loadTable()
      },

      handleOk(){
        this.$emit("callback", this.table.selectionRows);
      }
    }
  }
</script>

<style  scoped>
  .div {
    display: flex;
    align-items: center;
    height: 500px
  }

  .ant-tree{
    font-size: 20px;
    max-height: 500px;
    overflow-y: auto;
    min-width: calc(47vh);
  }



</style>